/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Status_Pre_TransitInputs */

const tr_geliver_status_pre_transit = /** @type {(inputs: Geliver_Status_Pre_TransitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilgi alındı, kurye bekleniyor`)
};

const en_geliver_status_pre_transit = /** @type {(inputs: Geliver_Status_Pre_TransitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registered, awaiting pickup`)
};

const de_geliver_status_pre_transit = /** @type {(inputs: Geliver_Status_Pre_TransitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfasst, wartet auf Abholung`)
};

const ru_geliver_status_pre_transit = /** @type {(inputs: Geliver_Status_Pre_TransitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Принято, ожидает курьера`)
};

/**
* | output |
* | --- |
* | "Registered, awaiting pickup" |
*
* @param {Geliver_Status_Pre_TransitInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_status_pre_transit = /** @type {((inputs?: Geliver_Status_Pre_TransitInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Status_Pre_TransitInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_status_pre_transit(inputs)
	if (locale === "de") return de_geliver_status_pre_transit(inputs)
	if (locale === "ru") return ru_geliver_status_pre_transit(inputs)
	return tr_geliver_status_pre_transit(inputs)
});